import React from 'react'
import Verify from './verify-page/VerifyEmail'

const VerifyEmail = () => {
  return (
    <>
        <Verify />
    </>
  )
}

export default VerifyEmail